export const ProviderRoutes = {
  LIST: "/settings/providers",
  CREATE: "/settings/providers/new",
  DETAIL: "/settings/providers/:id",
  EDIT: "/settings/providers/:id/edit",
} as const;
